import {
  Score,
  RelativelyLow,
  SeverityLabels,
  Significant,
  HighRange,
  VeryHighRange,
  ExtremeRange,
  scores_types,
} from "./types";
require("dotenv").config();

const { REACT_APP_MAPBOX_MAPS, REACT_APP_API_URL, REACT_APP_MAIN_URL } =
  process.env;

export const constants = {
  REACT_APP_MAPBOX_MAPS,
  REACT_APP_API_URL,
  REACT_APP_MAIN_URL,
};

export const extractNeededScores = (scores: any) => {
  const { SeaLevelScore, InlandFlood, ...scoresValues } = scores;
  return {
    ...scoresValues,
  };
};

export const formatScore = (key: scores_types, value: number): Score => {
  return {
    score: value > 0 ? value : 1,
    severity: getScoreSeverity(value),
    type: key,
  };
};

export const formatSortScores = (scores: any): Score[] => {
  const sortedKeys = Object.keys(scores).sort((a, b) => {
    return scores[a] > scores[b] ? -1 : 1;
  });

  const formattedScores = sortedKeys.map((key) => {
    return formatScore(key as scores_types, scores[key]);
  });

  return formattedScores as Score[];
};

const getScoreSeverity = (score: number): SeverityLabels => {
  let severity: SeverityLabels;
  if (score >= RelativelyLow.min && score <= RelativelyLow.max) {
    severity = SeverityLabels.relativelyLow;
  } else if (score >= Significant.min && score <= Significant.max) {
    severity = SeverityLabels.significant;
  } else if (score >= HighRange.min && score <= HighRange.max) {
    severity = SeverityLabels.high;
  } else if (score >= VeryHighRange.min && score <= VeryHighRange.max) {
    severity = SeverityLabels.veryHigh;
  } else if (score >= ExtremeRange.min && score <= ExtremeRange.max) {
    severity = SeverityLabels.extreme;
  } else {
    severity = SeverityLabels.more;
  }
  return severity;
};
